export default "__VITE_ASSET__CSa2Uw3___"